/**
 * 公共方法
 */
export default {
  install (Vue,options){
      var _this=Vue.prototype;
      var Common=Vue.prototype.$common={};

      /**
       * 在新页面打开
       * @param {*} $this
       * @param {*} routeName
       * @param {*} param 参数对象，对象格式
       */
      Common.OpenNewPage=function($this,routePath,param){
          let routeData=$this.$router.resolve({
              path:routePath,
              query:param
          });
          window.open(routeData.href,'_blank');
      }
      /**
       * 写入sessionStorage
       */
      Common.setSessionStorage=function(key,objData){
          if(typeof objData=='string'){
              sessionStorage.setItem(key,objData);
          }
          else{
              sessionStorage.setItem(key,JSON.stringify(objData));
          }

      }
      /**
       * 读取sessionStorage
       */
      Common.getSessionStorage=function(key,isObj){
          var data= sessionStorage.getItem(key);
          if(isObj){
              return JSON.parse(data);
          }
          return data;
      },
       /**
       * 移除sessionStorage
       */
      Common.removeSessionStorage=function(key){
          sessionStorage.removeItem(key);
      }
      ,

      /**
       * 写入localStorage
       */
      Common.setLocalStorage=function(key,objData){
          if(typeof objData=='string'){
              localStorage.setItem(key,objData);
          }
          else{
              localStorage.setItem(key,JSON.stringify(objData));
          }

      }
      /**
       * 读取localStorage
       */
      Common.getLocalStorage=function(key,isObj){
          var data= localStorage.getItem(key);
          if(isObj){
              return JSON.parse(data);
          }
          return data;
      },
       /**
       * 移除localStorage
       */
      Common.removeLocalStorage=function(key){
          localStorage.removeItem(key);
      },

      Common.timestampToTime =function(row, column) {
            var date = row[column.property];
            if (date == undefined) {
               return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
      },
      Common.toDate =function(timestamp) {
          if (timestamp == undefined) {
             return "";
          }
          return moment(timestamp).format("YYYY-MM-DD");
    },
      Common.isSuccess =function(data,callback) {
          if (data && data.data) {
              var json = data.data;
              if (json.status == 'SUCCESS') {
                  _this.$message({message: '执行成功',type: "success"});
                  callback(json);
              }
              else if (json.message) {
                  _this.$message({message: json.message,type: "error"});
              }
          }
          else{
              _this.$message({message: '执行异常，请重试',type: "error"});
          }
      }
      Common.extname=function(filename){
        if(!filename||typeof filename!='string'){
           return false
        };
        let a = filename.split('').reverse().join('');
        let b = a.substring(0,a.search(/\./)).split('').reverse().join('');
        return b
      };
	  Common.dateDiff=function(date){
	    let timestamp = Date.parse(new Date());
	    timestamp = timestamp / 1000;
		let timestamp2 = Date.parse(new Date(date));
		timestamp2 = timestamp2 / 1000;
		let nTime = timestamp - timestamp2;
		let day = Math.floor(nTime / 86400);
		return day
	  };
	  
		// 编码base64
		Common.encode_base64 = function(item) {
			return btoa(encodeURIComponent(item))
		}
		// 解码base64
		Common.decode_base64 = function(item) {
			return decodeURIComponent(atob(item))
		}
		
		// 构造url传参
		Common.makeURLParams = function(params = {}, url = '') {
			let URLParams = []
			for(let k in params) {
				URLParams.push(`${k}=${params[k]}`)
			}
			if(URLParams.length) {
				URLParams[0] = '?' + URLParams[0]
			}
			
			return url + URLParams.join('&')
		}
		
		// 解析路由传参
		Common.resolveURLParams = function(url = window.location.href) {
			let URLParams = ''
			if(url.indexOf('?') > -1) {
				URLParams = url.split('?')
				URLParams = URLParams[URLParams.length - 1].split('&')
				let obj = {}
				for(let item of URLParams) {
					let [k, v] = item.split('=')
					obj[k] = v
				}
				URLParams = obj
				obj = null
			}
			return URLParams
		}
  }
}



// WEBPACK FOOTER //
// ./src/assets/util.js